import React from 'react';
import { Route } from 'react-router-dom';

import HERAuthenticationLayer from './HERAuthenticationLayer';
import { HER_PATH } from '../../constants/paths';

const HERLayout = () => {
  return (
    <Route path={HER_PATH} component={HERAuthenticationLayer}/>
  );
}

export default HERLayout;